module.exports = __webpack_public_path__ + "static/media/Rec.f6d04d2c.png";